module.exports = __webpack_public_path__ + "static/media/446JamesPBrawleyDrNW_2018-06-12_168.67bd3983.jpg";